import React, { useState } from "react";
import "./style.scss";
import CreateNode from "@Common/CreateNode";
import { changeValByPath } from "@utils";
import { inject, observer } from "mobx-react";
import "./style.scss";
import moment from "moment";
import ButtonUI from "@UI/ButtonUI";
import CardUI from "@UI/CardUI";

const UnloadTotal = inject("mainStore")(
    observer(({ mainStore }) => {
        const vendors = mainStore.getMainStore("modified.vendors_suggest") || [];

        const [total, setTotal] = useState(null);
        const [data, setData] = useState({
            vendorId: null,
            siteIds: [],
            offerIds: [],
            bucketCode: null,
            dateStart: null,
            dateEnd: null,
        });
        const setStateData = (path, value) => {
            const field = path.join(".");
            setData((prev) => ({ ...prev, [field]: value }));
        };

        const setStateDataMulti = (array) => {
            let currentData = { ...data };
            array.forEach(({ path, value }) => {
                const fullPath = path.join(".");
                currentData = changeValByPath(fullPath, value, currentData);
            });
            setData(currentData);
        };

        const calculateHandler = async (type) => {
            if (type === "count") {
                const obj = { ...data, mode: `${type}` };

                const resp = await mainStore.postByUrl(`/reports/getPromoCodes`, obj, false, true, true);
                if (resp && resp.success) {
                    setTotal(resp.data);
                }
            } else {
                const obj = { ...data, mode: `${type}` };
                const startMonth = data.dateStart ? moment(data.dateStart).format("MMMM") : "";
                const endMonth = data.dateEnd ? moment(data.dateEnd).format("MMMM") : "";
                const monthLabel = startMonth && endMonth ? (startMonth === endMonth ? startMonth : `${startMonth}–${endMonth}`) : moment().format("MMMM");

                const resp = await mainStore.downloadFile(
                    `/reports/getPromoCodes`,
                    obj,
                    {
                        headers: {
                            "content-type": "application/json",
                        },
                    },
                    `RIS_${vendors[data.vendorId].name}_${monthLabel}_промокоды.csv`,
                    true,
                );
            }
        };

        const isFormValid = Object.entries(fields)
            .filter(([_, field]) => field.required)
            .every(([key]) => {
                const val = data[key];
                return Array.isArray(val) ? val.length > 0 : !!val;
            });

        return (
            <div className="unload-total">
                <CardUI
                    title={() => (
                        <span className="unload-total__title">
                            Выгрузка / <span className="unload-total__title_gray">Выдача тотал</span>
                        </span>
                    )}
                >
                    {Object.keys(fields).map((key) => {
                        const val = data && data[key] ? data[key] : "";
                        return (
                            <CreateNode
                                key={key}
                                fullData={data}
                                keyTo={key}
                                item={fields[key]}
                                value={val}
                                setDataMulti={setStateDataMulti}
                                setStateData={setStateData}
                                isAdd={false}
                                dataId={[key]}
                                disabled={false}
                                siteId={null}
                                multiple={false}
                                changeableData={data}
                            />
                        );
                    })}

                    <div className="unload-total__buttons">
                        <ButtonUI label="Рассчитать" icon="pi pi-sync" onClick={(e) => calculateHandler("count")} disabled={!isFormValid} />
                        {total != null ? <div className="">{total}</div> : null}
                        <ButtonUI severity="success" icon="pi pi-download" label="Выгрузить" onClick={(e) => calculateHandler("report")} disabled={!isFormValid} />
                    </div>
                </CardUI>
            </div>
        );
    }),
);

export default UnloadTotal;

const fields = {
    vendorId: {
        label: "Выберите вендора",
        type: "select",
        dataKey: "suggest.vendors_suggest",
        optionValue: "_id",
        optionLabel: "name",
        selectedItemKey: "_id",
        filterBy: "name,_id",
        showSelectAll: true,
    },
    siteIds: {
        label: "Выберите витрину на котором используются",
        type: "multiSelect",
        dataKey: "suggest.sites_suggest",
        optionValue: "_id",
        optionLabel: "name",
        selectedItemKey: "_id",
        filterBy: "name,_id",
        showSelectAll: true,
    },
    offerIds: {
        label: "Выберите офферы",
        type: "multiSelect",
        dataKey: "suggest.offers_suggest",
        optionValue: "_id",
        optionLabel: "title",
        selectedItemKey: "_id",
        filterBy: "title,_id",

        showSelectAll: true,
        filterFunction: ({ options, currentValue }) => {
            if (currentValue.vendorId && currentValue.vendorId.length && options && options.length > 0) {
                let newOptions = options.filter((it) => {
                    return currentValue.vendorId === it.vendorId;
                });

                return newOptions;
            }
            return [];
        },
    },

    bucketCode: {
        label: "Выберите коризну",
        type: "select",
        apiUrl: "/promo/suggest_list?collection=buckets&project[_id]=1&project[code]=1&project[title]=1&project[vendorId]=1&project[offerIds]=1",
        dataKey: "suggest.buckets_suggest",
        optionValue: "code",
        optionLabel: "title",
        selectedItemKey: "value",
        filterBy: "title,_id",
        showSelectAll: true,
        filterFunction: ({ options, currentValue }) => {
            if (currentValue.vendorId && currentValue.vendorId.length && options && options.length > 0) {
                return options.filter((it) => {
                    return currentValue.vendorId === it.vendorId;
                });
            }
            return [];
        },
    },

    dateStart: { label: "Дата начала периода", type: "date", required: true, dataKey: "unload_leads_dateStart" },
    dateEnd: { label: "Дата окончание периода", type: "date", required: true, dataKey: "unload_leads_dateEnd" },
};
